import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PATH_LOGIN } from '../constants';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const paths = [PATH_LOGIN, '/auth/recover', '/auth/reset-password']

  if (authService.isAuthenticated()) {
    // Redirige al dashboard si intenta acceder a login o recover estando logueado
    if (state.url.startsWith('/auth')) {
      router.navigate(['/dashboard']);
      return false;
    }
    return true;
  } else {
    // Permite el acceso a login y recover si no está logueado
     const url = state.url.split('?')[0];
    if (paths.includes(url)) {
      return true;
    }
    // Redirige a login por defecto si intenta acceder a otras rutas
    router.navigate([PATH_LOGIN]);
    return false;
  }
};

